export default function initShowMoreBlock() {
	var duration = 400;
	var activeClass = 'show-more-active';

	jQuery('.show-more-block[data-lines]').each((i, holder) => {
		var $holder = jQuery(holder);
		var $block = $holder.find('.show-more-inner');
		var $linkMore = $holder.find('.link-more');
		var lines = $holder.data('lines') || 3;
		var lineHeight = parseFloat(getStyle($block[0], 'line-height'));
		var h = Math.ceil(lineHeight * lines) + 0.5;
		var resetTimer = null;
		var isAnimated = false;

		const resizeObserver = new ResizeObserver(setHeight);

		resizeObserver.observe($block[0]);

		function setHeight() {
			lineHeight = parseFloat(getStyle($block[0], 'line-height'));
			h = Math.ceil(lineHeight * lines) + 0.5;

			if ($block.prop('scrollHeight') > h) {
				$holder.addClass('show-more-link');
				$linkMore.show();

				if (!$holder.hasClass(activeClass)) {
					$block.css({
						'max-height': h,
						'overflow': 'hidden'
					});
				}

			} else {
				$holder.removeClass('show-more-link');
				$linkMore.hide();
			}
		}

		function toggleMore() {
			if (isAnimated) {
				return;
			}

			isAnimated = true;

			clearTimeout(resetTimer);

			if (!$holder.hasClass(activeClass)) {
				$holder.addClass(activeClass);

				$block.css({
					'transition-duration': `${duration}ms`,
					'max-height': $block.prop('scrollHeight')
				});

				resetTimer = setTimeout(function() {
					isAnimated = false;

					$block.css({
						'transition-duration': `0ms`,
						'max-height': ''
					});
				}, duration);
			} else {
				$holder.removeClass(activeClass);

				$block.css({
					'transition-duration': `0ms`,
					'max-height': $block.prop('scrollHeight')
				});

				setTimeout(function() {
					$block.css({
						'transition-duration': `${duration}ms`,
						'max-height': h
					});

					isAnimated = false;
				});
			}
		}

		setHeight();

		$linkMore.on('click', toggleMore);
	});

	function getStyle(el, styleprop) {
		if (window.getComputedStyle) {
			return document.defaultView.getComputedStyle(el, null).getPropertyValue(styleprop);
		} else if (el.currentStyle) {
			return el.currentStyle[styleprop.encamel()];
		}
		return null;
	}
}